import './index.css';

import App from './App';
import { Provider } from 'react-redux';
import { persistedStore, store } from './store';
import { createRoot } from "react-dom/client";
import reportWebVitals from './reportWebVitals';
import { PersistGate } from 'redux-persist/integration/react';


const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistedStore}>
      <App />
    </PersistGate>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();